import React, { useEffect, useRef, useState } from 'react';
import './menu-item.css';
import icons from './icons.js';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { isChildOpenAtom, isFrostyAtom, openAppAtom } from '../recoil/isChildOpenAtom';
import $, { nodeName } from 'jquery';
import { useHistory } from "react-router-dom";
import Badge from './Badge';

import './AppIcon.css';
//import Phone from './apps/Phone';
//import Camera from './apps/Camera';


const AppIcon = ({
    appName,
    item,
    pagenumber,
    icon,
    iconStyle,
    shortText,
    badge,
}) => {

    let history = useHistory();

    //const [isThisAppOpen, setIsThisAppOpen] = useState(false);

    //const [isChildOpen, setIsChildOpen] = useRecoilState(isChildOpenAtom);
    const setIsChildOpen = useSetRecoilState(isChildOpenAtom);
    //const [isFrosty, setIsFrosty] = useRecoilState(isFrostyAtom);
    //const [openApp, setOpenApp] = useRecoilState(openAppAtom);
    const setOpenApp = useSetRecoilState(openAppAtom);
    const divRef = useRef();

    
    //console.log(`AppIcon ${appName} render()`);


    const clicked = () => {

        const marginTopOnPageGrid = 70; // This has to be kept in sync with .page-grid margin-top
        const bottomBarFudgeFactor = marginTopOnPageGrid + 105; // Fixes the offset for bottom bar

        // hack to show and hide the fullscreen area
        document.querySelector('.fullscreen-area').style.opacity = 1;

        // Get offset top and left
        let offsetTop = 0;
        let offsetLeft = 0;
        if (divRef && divRef.current) {
            //const { offsetTop, offsetLeft, offsetHeight } = divRef.current;
            //console.log('divRef.current', divRef.current);
            //console.log({ offsetTop, offsetLeft, offsetHeight });
            offsetTop = divRef.current.offsetTop + marginTopOnPageGrid;
            offsetLeft = divRef.current.offsetLeft;
        }

        console.log('clicked', offsetTop, offsetLeft);

        // we switch transition off real quick so we can set the top and left, right, bottom without triggering animation (which takes time)
        // $('.fullscreen-area').css({
        //     transition: 'none'
        // });

        let offsetFolderTop = 0;
        let offsetFolderLeft = 0;
        const folderGridEl = document.querySelector('.folder-item[data-isclosed=false] .folder-grid-area');
        if (folderGridEl) {
            const bounding = folderGridEl.getBoundingClientRect();
            console.log('folderGridEl', folderGridEl, folderGridEl.top, folderGridEl.left);
            // offsetFolderTop = folderGridEl.offsetTop;
            // offsetFolderLeft = folderGridEl.offsetLeft;
            offsetFolderTop = bounding.top;
            offsetFolderLeft = bounding.left;
            console.log('offsetFolder', offsetFolderTop, offsetFolderLeft);
        }

        let verticalFudgeFactor = 0;
        let horizontalFudgeFactor = 0;
        // We modify the fudge factor special for the items in the bottom bar
        if (pagenumber === -1) {
            verticalFudgeFactor = window.innerHeight - bottomBarFudgeFactor;
            horizontalFudgeFactor = 20;
        }
        // We modify the fudge factor special for items in a folder
        if (pagenumber === -2) {
            verticalFudgeFactor = offsetFolderTop - 70;
            horizontalFudgeFactor = offsetFolderLeft + 0;
        }
        // $('.fullscreen-area').css({
        //     top: offsetTop + verticalFudgeFactor,
        //     left: offsetLeft + horizontalFudgeFactor,
        //     right: window.innerWidth - offsetLeft - 60 - horizontalFudgeFactor,
        //     bottom: window.innderHeight - offsetTop - 60 - verticalFudgeFactor,
        // });

        $('.fullscreen-area').css({
            top: offsetTop + verticalFudgeFactor,
            left: offsetLeft + horizontalFudgeFactor,
            //width: '50px',
            //height: '50px'
        });
        

        //let thisitem = icons[item - 1];

        
        // add the top & left position of this element
        const newItem = {
            //...thisitem,
            appName: appName,
            top: offsetTop + verticalFudgeFactor,
            left: offsetLeft + horizontalFudgeFactor,
            //right: window.innerWidth - offsetLeft - 60 - horizontalFudgeFactor,
            //bottom: window.innderHeight - offsetTop - 60 - verticalFudgeFactor,
            // height: '50px',
            // width: '50px',
            icon: icon,
            pagenumber: pagenumber, // -1 for bottom bar items
            shortText,
        };
        setOpenApp(newItem);
        
        setIsChildOpen(curr => !curr);
        //setIsFrosty(curr => !curr);
        //setIsThisAppOpen(true);

        // TODO: fix this to be the active page - for the scale() effect on app launch
        // So it will work for bottom bar app launch, and also app inside folder launch
        const activepage = pagenumber === -1 ? 1 : pagenumber;

        divRef.current.setAttribute('data-isopen', 'true');
        const pageEl = document.querySelector(`#page-${activepage}`);
        if (pageEl) {
            pageEl.setAttribute('data-isopen', 'true');
        }

        history.push('/app/' + appName);
        
    };

    // grab the item info from icons array
    // let thisitem = icons[item - 1];
    // if (!thisitem) {
    //     // fallback to default icon if it can not be found
    //     thisitem = {
    //         name: 'default',
    //         icon: '1492509273_camera_ios7_ios_7.png'
    //     }
    // }

    //const appIconClass = isChildOpen ? 'page-grid-item menu-item selected' : 'page-grid-item menu-item';
    //const appIconClass = isChildOpen ? 'menu-item selected' : 'menu-item';

    //let styl = {};

    // how can we refactor to not do this?
    // useEffect(() => {
    //     if (isChildOpen === false) {
    //         setIsThisAppOpen(false);
    //     }
    // }, [isChildOpen]);

    return (
        <div ref={divRef} className="app-item">
            {badge && <Badge badge={badge} />}
            <div className={'app-item-icon'} style={iconStyle} onClick={clicked}>
                <img alt={`${appName} icon`} src={icon}  />
            </div>
            {pagenumber !== -1 && <div className="app-item-text">
                {appName && <span>{appName}</span>}
                {!appName && <span>MenuItem P{pagenumber}-R{row}-I{item}</span>}
            </div>}
        </div>
    );
  
};

export default AppIcon;
